import { useRouter } from 'next/router';
import { updateRouterQuery } from 'lib/utils/filterUtils';
import {
  Select, MenuItem, FormControl, InputLabel,
} from '@mui/material';

interface Props {
  selected?: any;
}

type Statuses = 'closed' | 'open' | 'draft' | 'all';

export const StatusFilter = ({ selected }: Props) => {
  const router = useRouter();

  const defaultValue = 'open';

  const statusOptions = {
    open: 'Open',
    closed: 'Closed',
    draft: 'Draft',
    all: 'All',
  };

  const allTypes = Object.keys(statusOptions);

  const onChange = (n: string) => {
    if (n === '' || n === defaultValue) {
      updateRouterQuery(router, { status: [] });
      return;
    }

    updateRouterQuery(router, { status: n });
  };

  const onClose = (): void => {
    setTimeout(() => {
      (document?.activeElement as HTMLInputElement)?.blur();
    }, 0);
  };

  return (
    <FormControl className="w-full" size="small">
      <InputLabel id="statusLabel">Status</InputLabel>
      <Select
        className="w-full"
        label="status"
        labelId="statusLabel"
        id="status"
        onClose={onClose}
        onChange={(e) => onChange(e.target.value as string)}
        value={selected || defaultValue}
      >
        {allTypes.map(
          (key: string) => (
            <MenuItem key={key} value={key}>
              {statusOptions[key as Statuses]}
            </MenuItem>
          ),
        )}
      </Select>
    </FormControl>
  );
};
